import { Inject, Injectable } from "@angular/core";
import { TechUsed } from "./about.models";
import { CVApiService } from '../reusables/services/cv-api.service';

@Injectable({
    providedIn: 'root'
})
export class AboutService {

    constructor(
        private cvApiService: CVApiService, // Inject not needed, since it's already written in TypeScript
    ) { }

    /**
     * Initial data load. Loads tech information
     * */
    public async loadTechsUsed() {
        try {
            let response = await this.cvApiService.get<TechUsed[]>(`/api/v1/techUsed`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error(`Failed to retrieve initial data load for technology information.`);
            throw err;
        }
    }
}